import { Box, Slider, useTheme } from '@mui/material';

import { FilterFieldContainer, FilterLabel } from '../GeneratikTableFilterPanel.styles';
import { SliderFieldProps } from '../GeneratikTableFilterPanel.types';
import { getSliderSx, sliderBoxSx } from './SliderFilterField.styles';

const SliderFilterField = ({ field, value, onChange, disabled }: SliderFieldProps) => {
  const theme = useTheme();
  const min = field.minValue ?? 0;
  const max = field.maxValue ?? 100;
  const step = field.step ?? 1;
  const currentValue: [number, number] = [value.min ?? min, value.max ?? max];

  return (
    <FilterFieldContainer>
      <FilterLabel>{field.label}</FilterLabel>
      <Box sx={sliderBoxSx}>
        <Slider
          data-testid={`filter-field-${field.id}`}
          value={currentValue}
          onChange={(_, newValue) => {
            const [newMin, newMax] = newValue as [number, number];
            onChange({ min: newMin, max: newMax });
          }}
          valueLabelDisplay="auto"
          valueLabelFormat={field.formatLabel}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          sx={getSliderSx(theme)}
        />
      </Box>
    </FilterFieldContainer>
  );
};

export default SliderFilterField;
